import axios from "axios";
import DecryptData from "../Components/Utils/Decrypt";
import EncryptData from "../Components/Utils/Encrypt";
import logout from "../Components/Utils/Logout";

const SERVER_URL = window.WEB_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: SERVER_URL,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Request interceptor to add the token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = DecryptData("nEkOtReSuEdArT") || "";
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle token expiration and refresh
axiosInstance.interceptors.response.use(
  (response) => {
    // Check for specific response messages indicating token issues in success responses
    const { message, error } = response.data || {};
    console.log("interceptors", message, error);

    if (
      message === "Token missing" ||
      error === "Token is invalid" ||
      error === "Force Logout" ||
      error?.toLowerCase() === "force logout" ||
      message?.includes("Session expired by administrator")
    ) {
      logout();
      console.log("logout1");
      return Promise.reject(
        new Error("Token issue detected. User logged out."),
      );
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (!error.response) {
      return Promise.reject(
        new Error("Network error or no response from server."),
      );
    }

    const { status, data } = error.response;
console.log("interceptor2",status,data);

    // Handle explicit Force Logout or invalid token errors where refresh should NOT be attempted
    if (
      data?.error === "Force Logout" ||
      data?.error?.toLowerCase() === "force logout" ||
      data?.message === "Session expired by administrator. Please login again." ||
      data?.message?.includes("Session expired by administrator") ||
      data?.error === "Token missing" ||
      data?.error === "Token is invalid" ||
      data?.message === "Token missing" ||
      data?.message === "Token is invalid" ||
      data?.msg === "Token missing" ||
      data?.msg === "Token is invalid"
    ) {
      logout();
      console.log("logout2");

      return Promise.reject(new Error(data?.message || data?.error || "Unauthorized access. User logged out."));
    }

    // Handle 401 Unauthorized errors
    if (status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.token = token;
            return axiosInstance(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = DecryptData("nEkOtHsErFeRrEsUeDaRt");

      if (!refreshToken) {
        logout();
        console.log("logout3");

        return Promise.reject(
          new Error("Refresh token missing. User logged out."),
        );
      }

      try {
        const response = await axios.post(`${SERVER_URL}/auth/refresh`, {
          refresh_token: refreshToken,
        });

        if (response.data.status) {
          const newToken = response.data.token;
          EncryptData(newToken, "nEkOtReSuEdArT");

          if (response.data.refresh_token) {
            EncryptData(response.data.refresh_token, "nEkOtHsErFeRrEsUeDaRt");
          }

          axiosInstance.defaults.headers.common["token"] = newToken;
          originalRequest.headers.token = newToken;

          processQueue(null, newToken);
          return axiosInstance(originalRequest);
        } else {
          processQueue(new Error("Refresh failed"), null);
          // logout();
          console.log("logout4");

          return Promise.reject(
            new Error("Token refresh failed. User logged out."),
          );
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        // logout();
        console.log("logout5");

        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
